import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Dialog, P } from '@a-type/ui';
import { useEffect, useState } from 'react';
import { useIsLoggedIn } from '../hooks/graphql.js';
import { useWasLoggedIn } from '../hooks/useWasLoggedIn.js';
import { LoginButton } from './LoginButton.js';
export function LogoutNotice({}) {
    const [wasLoggedIn, setWasLoggedIn] = useWasLoggedIn();
    const [isLoggedIn, loadingLoggedInStatus] = useIsLoggedIn();
    const [close, setClose] = useState(false);
    const isLoginPage = window.location.pathname === '/login' ||
        window.location.pathname === '/verify';
    const wasLoggedInButNowLoggedOut = !close && wasLoggedIn && !isLoggedIn && !loadingLoggedInStatus;
    // only want to fire this when session changes, not when flag changes.
    // flag can be reset manually.
    useEffect(() => {
        if (isLoggedIn) {
            setWasLoggedIn(true);
        }
    }, [isLoggedIn, setWasLoggedIn]);
    if (isLoginPage)
        return null;
    return (_jsx(Dialog, { open: wasLoggedInButNowLoggedOut, onOpenChange: setWasLoggedIn, children: _jsxs(Dialog.Content, { children: [_jsx(Dialog.Title, { children: "Session expired" }), _jsx(P, { children: "To resume syncing your data, please sign in again." }), _jsxs(Box, { items: "center", justify: "end", gap: "sm", children: [_jsx(Dialog.Close, { render: _jsx(Button, { emphasis: "ghost" }), children: "Cancel" }), _jsx(Dialog.Close, { render: _jsx(LoginButton, { emphasis: "primary", onClick: () => setClose(true) }), children: "Sign in" })] })] }) }));
}
//# sourceMappingURL=LogoutNotice.js.map